/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export interface Entity<T> {
  byId: Record<string, T>;
  allIds: string[];
}

export const createEntity = <T>(ids: string[] = [], items: Record<string, T> = {}): Entity<T> => {
  if (ids.length === Object.keys(items).length && ids.every((id) => Object.hasOwn(items, id))) {
    return {
      byId: JSON.parse(JSON.stringify(items)),
      allIds: [...ids],
    };
  }

  return {
    byId: {},
    allIds: [],
  };
};

export const removeEntityId = <T>(entity: Entity<T>, id: string): Entity<T> => {
  delete entity.byId[id];
  const index = entity.allIds.indexOf(id);
  if (index >= 0) {
    entity.allIds.splice(index, 1);
  }
  return entity;
};

export const addOrUpdateEntityItem = <T>(entity: Entity<T>, item: T, id: string): Entity<T> => {
  entity.byId[id] = item;
  if (!entity.allIds.includes(id)) {
    entity.allIds.push(id);
  }
  return entity;
};
